import { handleActions } from 'redux-actions';
import { types } from './actions';
import assign from 'lodash/assign';
import {
  getInitialSessionType,
  getSessionProfiles,
  getProfileForMode,
  resolveCommunitySwitch,
  resolveModeSwitch
} from './modeHelpers';

const initialState = {
  isAuthenticationInProgress: false,
  isAuthenticated: false,
  hasAuthenticationFailed: false,
  apiErrors: null,
  user: null,
  units: [],
  // Current profile for the logged user
  // Is used to get the community id to perform
  // calls to the API
  profile: null,
  // Profiles for the current session mode
  profiles: [],
  type: null
};

const reducer = handleActions(
  {
    [types.getIndividualUnitsSuccess]: (state, action) => {
      return {
        ...state,
        units: action.payload
      };
    },
    [types.authenticationInProgress]: state => {
      return {
        ...state,
        isAuthenticationInProgress: true,
        isAuthenticated: false,
        hasAuthenticationFailed: false,
        apiErrors: null,
        user: null,
        profile: null,
        profiles: [],
        type: null
      };
    },
    [types.authenticationFail]: (state, action) => {
      return {
        ...state,
        isAuthenticationInProgress: false,
        isAuthenticated: false,
        hasAuthenticationFailed: true,
        apiErrors: action.payload.apiErrors,
        user: null,
        profile: null,
        profiles: [],
        type: null
      };
    },
    [types.authenticationSuccess]: (state, action) => {
      const userSession = action.payload.session;
      const sessionType = getInitialSessionType(userSession);
      const sessionProfiles = getSessionProfiles(userSession, sessionType);
      const profile = getProfileForMode(userSession, sessionType, null);

      return {
        ...state,
        isAuthenticationInProgress: false,
        isAuthenticated: true,
        hasAuthenticationFailed: false,
        apiErrors: null,
        user: userSession,
        type: sessionType,
        profile,
        profiles: sessionProfiles
      };
    },
    [types.refreshTokenSuccess]: (state, action) => {
      const session = state.user;
      return {
        ...state,
        user: assign(session, action.payload)
      };
    },
    [types.updateActiveProfile]: (state, action) => {
      const selectedCommunity = action.payload;
      const { sessionType, profile, profiles } = resolveCommunitySwitch(
        state.user,
        selectedCommunity,
        state.type
      );

      return {
        ...state,
        type: sessionType,
        profile: profile || state.profile,
        profiles
      };
    },
    [types.updateSessionMode]: (state, action) => {
      const nextMode = action.payload;
      const currentCommunityId = state.profile?.community?.id;
      const { sessionType, profile, profiles } = resolveModeSwitch(
        state.user,
        nextMode,
        currentCommunityId
      );

      return {
        ...state,
        type: sessionType,
        profile: profile || state.profile,
        profiles
      };
    },
    [types.logOff]: () => {
      return initialState;
    }
  },
  initialState
);

export default reducer;
